import { Badge, Column, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useCobConfig } from "../../../../CobConfigContext";
import { SignatureInput } from "../../../../components/SignatureInput";
import { useStore } from "../../../../../../contexts";
import { fullName } from "../../../../../../infra/utils";
import { relationshipModel } from "../../../../../../models";
import { selectors } from "../../../../../../store/state-selectors";
import { useSignAndApproveContext } from "../../../hooks/useSignAndApprove";
import styles from "./SignAndApprove.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const {
  SignAndApproveTestIds
} = getTestIds();
function AdditionalSignatories(_ref) {
  var _relationship$signato, _relationshipModel$bu;
  let {
    relationship,
    userId
  } = _ref;
  const signatories = (_relationship$signato = relationship.signatories) !== null && _relationship$signato !== void 0 ? _relationship$signato : [];
  const isBuyer = relationshipModel.isBuyer(relationship, userId);
  const rows = isBuyer ? signatories.map(s => {
    var _fullName;
    return {
      name: (_fullName = fullName(s.firstName, s.lastName)) !== null && _fullName !== void 0 ? _fullName : s.email,
      status: s.approvalRecord ? 'Signed' : 'Awaiting signature'
    };
  }) : [...(relationship.buyer.id !== userId ? [{
    name: (_relationshipModel$bu = relationshipModel.buyerFullName(relationship)) !== null && _relationshipModel$bu !== void 0 ? _relationshipModel$bu : relationship.buyer.email,
    status: relationship.approvalRecord ? 'Signed' : 'Awaiting signature'
  }] : []), ...signatories.filter(s => s.id !== userId).map(s => {
    var _fullName2;
    return {
      name: (_fullName2 = fullName(s.firstName, s.lastName)) !== null && _fullName2 !== void 0 ? _fullName2 : s.email,
      status: s.approvalRecord ? 'Signed' : 'Awaiting signature'
    };
  })];
  if (rows.length === 0) return null;
  return /*#__PURE__*/_jsxs(Column, {
    gap: 8,
    alignItems: "start",
    testId: SignAndApproveTestIds.AdditionalSignatories(),
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "paragraph1",
      weight: "bold",
      children: "Additional signatories"
    }), rows.map((row, i) => /*#__PURE__*/_jsxs(Row, {
      className: styles.signatoryRow,
      gap: 8,
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "paragraph1",
        skin: "secondary",
        children: row.name
      }), /*#__PURE__*/_jsx(Badge, {
        rounded: true,
        outlined: true,
        skin: "primary",
        className: styles.statusBadge,
        children: row.status
      })]
    }, i))]
  });
}
export const SignAndApprove = () => {
  const {
    relationship
  } = useCobConfig();
  const userId = useStore(selectors.user.id);
  const {
    signature,
    setSignature,
    baseDisabled
  } = useSignAndApproveContext();
  return /*#__PURE__*/_jsxs(Column, {
    gap: 24,
    alignItems: "start",
    children: [/*#__PURE__*/_jsx(SignatureInput, {
      value: signature,
      onChange: setSignature,
      disabled: baseDisabled,
      placeholder: "Type your name..."
    }), relationshipModel.hasSignatories(relationship) && /*#__PURE__*/_jsx(AdditionalSignatories, {
      relationship: relationship,
      userId: userId
    })]
  });
};